export default "__VITE_ASSET__GsaqI8bS__"